/* ============================================================
  main.js
============================================================ */

$(function () {
  if ($('.js-slider').length) {
    $('.js-slider').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 800,
      dots: true,
      arrows: true,
      infinite: true,
      fade: false,
      pauseOnHover: true,
      pauseOnFocus: true,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 640,
          settings: {},
        },
      ],
    });
  }
});

(function () {
  var targets = document.querySelectorAll('.js-fadeup');
  if (!targets.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  targets.forEach(function (el) { observer.observe(el); });
})();
